<section
  class="relative flex w-full overflow-y-visible bg-white theme-border"
  [class.overflow-x-auto]="scrollEnabled()"
  [attr.data-theme]="theme()"
>
  @for (option of options(); track $index) {
  <div
    #item
    [attr.data-theme]="theme()"
    class="option"
    [ngClass]="
      value() === option.value ? 'border-b-2 border-primary' : 'border-b '
    "
    (click)="handleClick(option)"
  >
    @if (option.icon; as icon) {
    <app-icon [attr.data-theme]="theme()" class="option-text" [name]="icon" />
    }
    <div
      [attr.data-theme]="theme()"
      [class.active]="value() === option.value"
      class="text-base transition-colors duration-200 ease-in-out option-text"
    >
      {{ option.label }}
    </div>
    @if (option.count; as count) {
    <div
      class="flex items-center justify-center px-2 py-0.5 pb-1 text-sm rounded-md min-w-max bg-primary-100"
    >
      {{ count | number }}
    </div>
    }
  </div>
  }
  <div
    #indicator
    [attr.data-color]="color()"
    class="absolute transition-all duration-300 ease-in-out indicator"
    style="height: 0.15rem"
    [style.bottom]="scrollEnabled() ? 0 : '-0.15rem'"
  ></div>
</section>
